import { createContext, Dispatch, SetStateAction, useContext } from "react";

type LoggedContextValue = {
    auth: boolean,
    setAuth: Dispatch<SetStateAction<boolean>>
}

export const LoggedContext = createContext<LoggedContextValue | null>(null);

export const useLoggedContext = () => {
    const context = useContext(LoggedContext);

    if (!context) {
        throw new Error('useLoggedContext si può usare solo negli elementi wrappati da LoggedContext.Provider')
    }

    return context;
}